import Bus from "../core/Bus.js";
import { GcSessionInfo } from "@glamcorner/gc-types/generated/types";
import { MainWebsiteEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";

interface FormKeyResponse {
  formKey: string;
}

async function fetchFormKey(): Promise<string> {
  const response = await fetch("/gcsession/index/formKey");
  const data = (await response.json()) as FormKeyResponse;

  return data.formKey;
}

function setupVisibilityListener(originalFormKey: string) {
  window.addEventListener("focus", async () => {
    const currentFormKey = await fetchFormKey();

    if (originalFormKey !== currentFormKey) {
      window.location.reload();
    }
  });
}

export function initialiseSessionExpirationChecker(bus: Bus) {
  bus.on(MainWebsiteEvents.GcSessionXhrFinished, {}, (session: GcSessionInfo) => {
    const originalFormKey = session.formKey;
    setupVisibilityListener(originalFormKey);
  });
}
